<template>
<div class="step-content map row">
    <div class="col-md-12">
        <div class="col-md-12 localisation-btn col-xl-4" style="z-index: 9999">
            <button type="button" class="btn btn-primary" @click.prevent="chooseCurrentLocation()">
                <i class="fas fa-crosshairs"></i>
                <!--   <span class="button-label">{{ $t("location.use_current_location") }}</span>-->
            </button>
        </div>
        <div class="report-search-start">
            <div class="report-search form-group">
                <div class="row nopad">
                    <div class="col-md-12 col-xl-8 nopad">
                        <form novalidate @submit.prevent="">
                            <template v-if="item.required === 1">
                                <div class="input-group mb-3">
                                    <input class="location form-control form-control-user position-relative" :placeholder="$t('location.select_address')" type="search" maxlength="250" required="required" v-model="postalAddress" />
                                    <div class="input-group-append">
                                        <span class="search-icon bg-primary input-group-text "><i class="fas fa-search text-white"></i></span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="input-group mb-3">
                                    <input class="location form-control form-control-user position-relative" :placeholder="$t('location.select_address')" type="search" maxlength="250" v-model="postalAddress" />
                                    <div class="input-group-append">
                                        <span class="search-icon bg-primary input-group-text "><i class="fas fa-search text-white"></i></span>
                                    </div>
                                </div>
                            </template>

                            <ul class="resultList" v-show="locationsResult.length && resultFound === false">
                                <li v-for="result in locationsResult" @click.prevent="clickOnLocation(result)" :key="result.lat+','+result.lon">
                                    <i class="fas fa-map-marker-alt text-gray-500"></i>
                                    {{result.address}}

                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <l-map ref="myMap" style=" width: 100%; z-index:1;" class="mymapcss" :zoom="zoom" :center="center" @click="getLocation($event)" @update:zoom="zoomUpdated">
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-geo-json v-for="(city, index) in cities" :key="index" :geojson="city" :options="options" />
            <l-marker ref="maPosition" v-for="location in locations" :key="location.lat+location.lng" :icon="icon" :lat-lng="location">
                <l-popup>
                    <div> Ma position </div>
                </l-popup>
            </l-marker>

            <l-control class="leaflet-custom-control w-100 mr-0" v-if="tags.length > 0">
                <i @click.prevent="showPOIBox(!showPOIBoxContent)" class="fas fa-exclamation-triangle text-primary main-icon"></i>

                <div v-show="this.showPOIBoxContent === true" class="content pr-4 pl-4 pt-3 pb-3 btn text-left mr-auto ml-auto shadow w-75">
                    <div class="d-flex justify-content-between ">
                        <p class="font-weight-bold text-dark text-uppercase d-block ml-auto mr-auto mb-3">{{$t('location.poi')}}</p>
                        <i @click.prevent="showPOIBox(false)" class="fas fa-times text-gray-500"></i>
                    </div>
                    <div class="d-flex">
                        <div class="custom-control custom-switch flex-wrap d-flex flex-row p-0 " v-for="(tag, index) in tags" :key="tag.id">
                            <div class="d-flex flex-wrap border p-2">
                                <i :class="tag.icon" class="text-primary"></i>
                                <label class="custom-control-label" v-bind:class="{ active: tag.visible, 'bg-primary': tag.visible }" :for="tag.slug">
                                </label>
                                <input type="checkbox" class="custom-control-input d-block" :id="tag.slug" :checked="isTagChecked(index)" @change="toggleVisible(index)">
                            </div>
                            <div class="mt-1 mb-0 text-center text-dark" style="font-size: 13px">{{ tag.tag }}</div>
                        </div>
                    </div>
                </div>

            </l-control>
            <template v-for="(tag, index) in tags">
                <l-marker v-for="poi in tag.markers" :lat-lng="getLatLng(poi.coordinates)" :visible="shouldShow(index)" :key="poi.id">
                    <l-icon class-name="map-marker">
                        <i :class="poi.icon"></i>
                    </l-icon>
                    <l-popup>
                        <div>
                            <h4>{{ poi.name }}</h4>
                            <p>{{poi.description}}</p>
                        </div>
                    </l-popup>
                </l-marker>
                <l-polygon v-for="poi in tag.polygons" :lat-lngs="poi.coordinates" color="#2E59D8" :visible="shouldShow(index)" :key="poi.id">
                    <l-tooltip>
                        <div>
                            <h4>{{ poi.name }}</h4>
                            <p>{{poi.description}}</p>
                        </div>
                    </l-tooltip>
                </l-polygon>
            </template>
        </l-map>

    </div>
</div>
</template>

<style scoped>
/* reset style intégré a la map*/
</style>

<script>
import {
    EventManager
} from '@/components/Events/EventManager.js'
import 
    LocationService
from '@/service/LocationService.js'
require('leaflet.snogylop')
import {
    L,
    latLng,
    icon
} from "leaflet";
import {
    LMap,
    LTileLayer,
    LGeoJson,
    LPolygon,
    LMarker,
    LPopup,
    LIcon,
    LControl,
    LTooltip
} from 'vue2-leaflet';
export default {
    name: 'Location',
    components: {
        L,
        LMap,
        LTileLayer,
        LPolygon,
        LMarker,
        LGeoJson,
        LPopup,
        LTooltip,
        LIcon,
        LControl,
        EventManager,
        LocationService
    },
    props: ['item'],
    created() {    
        this.init();

        EventManager.$on('redraw', () => {
            this.redraw();
        });
    },
    watch: {
        postalAddress: function (newVal, oldVal) {
            if (newVal.length <= 0) {
                this.locationsResult = []
            }

            if (!this.resultClicked) this.resultFound = false;
            if (this.timeoutSearchAddress) {
                clearTimeout(this.timeoutSearchAddress);
            }
            this.timeoutSearchAddress = setTimeout(() => {
                this.searchAddress();
            }, 500);
            this.resultClicked = false;
        }
    },
    data: function () {
        return {
            map: this.$store.state.map,
            postalAddress: '',
            zoom: 0,
            center: {},
            cities: [],
            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidXNoYWhpZGkiLCJhIjoiY2lxaXUzeHBvMDdndmZ0bmVmOWoyMzN6NiJ9.CX56ZmZJv0aUsxvH5huJBw',
            attribution: '&copy; <a href="javascript:void(0)">OpenStreetMap</a>, &copy; <a href="javascript:void(0)">Mapbox</a> | <a href="javascript:void(0)" target="_blank">Improve the underlying map</a>',
            locations: [],
            showMap: true,
            showPOIBoxContent: false,
            options: {
                invert: true
            },
            imagePath: '',
            markers: [],
            polygons: [],
            tags: [],
            userSelectedLocation: {},
            timeout: {},
            timeoutSearchAddress: {},
            selectedLocationResult: '',
            locationsResult: [],
            resultFound: false,
            resultClicked: false,
            data: {},
            icon: null
        }
    },
    methods: {
        init:function(){
            this.locationService = new LocationService(LocationService.BING);

            // Préférences
            this.setImagePath();
            this.setIcon();      

            var config = this.map.default_view;
            this.zoom = config.zoom;
            this.center = latLng(config.lat, config.lon);
            
            // Init map data
            this.getPOI();
            this.initDelimiterZone();
        },
        initDelimiterZone:function(){
            var citiesPolygone = '';
            var citiesLength = this.map.citydata.cities.length - 1;
            this.map.citydata.cities.forEach(function (valueCity, key) {
                var mCity = valueCity['city'];
                if (mCity !== '') {
                    if (key < citiesLength) {
                        citiesPolygone = citiesPolygone.concat("[[" + mCity + "]]", ",");
                    } else if (key == citiesLength) {
                        citiesPolygone = citiesPolygone.concat("[[" + mCity + "]]");
                    }
                }
            });
            if (this.map.citydata.cities.length > 0) {
                var cities = "[" + citiesPolygone + "]";
                cities = JSON.parse(cities);
                var states = [{
                    "type": "Feature",
                    "geometry": {
                        "type": "MultiPolygon",
                        "coordinates": cities
                    }
                }];
                this.cities = states;
            }
        },
        getPOI:function(){
            const endpointRefresh = this.$store.state.vueAppModernApiUrl;
            this.axios.get(endpointRefresh + '/poi/tags').then((response) => {
                var tags = response.data.tags;
                for (var i = 0; i < tags.length; i++) {
                    var polygons = [];
                    var markers = [];
                    for (var j = 0; j < tags[i].pois_front.length; j++) {
                        var coordinates = tags[i].pois_front[j].coordinates.split(';');
                        if (coordinates.length > 1) {
                            var tabResultat = [];
                            for (var z = 0; z < coordinates.length; z++) {
                                var latLngTab = coordinates[z].split(',');
                                tabResultat.push([parseFloat(latLngTab[1]), parseFloat(latLngTab[0])]);
                            }
                            polygons.push({
                                'id': tags[i].pois_front[j].id,
                                'icon': tags[i].pois_front[j].icon,
                                'name': tags[i].pois_front[j].name,
                                'description': tags[i].pois_front[j].description,
                                'coordinates': tabResultat
                            });
                        } else {
                            var latLngTab = tags[i].pois_front[j].coordinates.split(',');
                            markers.push({
                                'id': tags[i].pois_front[j].id,
                                'icon': tags[i].pois_front[j].icon,
                                'name': tags[i].pois_front[j].name,
                                'description': tags[i].pois_front[j].description,
                                'coordinates': [latLngTab[0], latLngTab[1]]
                            });
                        }
                    }
                    this.tags.push({
                        'id': tags[i].id,
                        'tag': tags[i].tag,
                        'description': tags[i].description,
                        'icon': tags[i].icon,
                        'slug': tags[i].slug,
                        'markers': markers,
                        'polygons': polygons
                    });
                }
            });
        },
        setImagePath:function(){
            if (process.env.VUE_APP_STANDALONE === 'true') {
                this.imagePath = '/img/target.png';
            } else {
                this.imagePath = this.$store.state.vueAppBaseUrl + '/dist/img/target.png';
            }
        },
        setIcon:function(){
            this.icon = icon({
                iconUrl: this.imagePath,
                iconSize: [37, 37],
                iconAnchor: [18, 18]
            })
        },
        searchAddress: function () {
            this.locationsResult = [];

            var country = process.env.VUE_APP_MAP_COUNTRY_RESTRICTION
            var searchAddress = this.postalAddress.trim();

            if(country && country.length > 0){
                if(!searchAddress.toLowerCase().includes(country.toLowerCase())){
                    searchAddress += ' '+country
                }
            }
            
            this.locationService.search(searchAddress).then((results) => {
                this.locationsResult = results;
            }).catch((error) => {
                console.log('[Location.vue] error')
                console.log(error)
            })
        },        
        showPOIBox: function (shouldShow) {
            this.showPOIBoxContent = shouldShow;
        },
        chooseCurrentLocation: function () {
            if (!("geolocation" in navigator)) {
                console.log('Geolocation is not available.')
                return;
            }
            navigator.geolocation.getCurrentPosition(pos => {
                this.resultFound = true;
                this.resultClicked = true;
                this.locations = [];
                var lat = pos.coords.latitude;
                var lon = pos.coords.longitude;
                this.locations.push(latLng(lat, lon));
                this.center = latLng(lat, lon);               
                var promise = this.getPostalLocation(lat, lon);
                promise.then(() => {
                    this.setLocation(lat,lon);
                }) 

            }, err => {});
        },
        handleGMapsResults:function(results){
            console.log(results)
        },
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        redraw: function () {
            this.$nextTick(() => {
                if(this.$refs.myMap)
                    this.$refs.myMap.mapObject.invalidateSize();
            });
        },
        setLocation: function (lat, lon) {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            var key;
            if (this.item.hasOwnProperty('attributes') && this.item.attributes[0].key) {
                key = this.item.attributes[0].key;
            } else {
                key = this.item.key;
            }
            var content = {};
            content[key] = {
                "address": this.postalAddress,
                'lat': lat,
                'lon': lon
            }
            this.data = {
                'key': key,
                'content': content
            };
            this.timeout = setTimeout(() => {
                this.$emit('selected', this.data);
            }, 1000);
        },
        getPostalLocation: function (lat, lon) {
            return new Promise((resolve, reject) => {
                this.locationService.reverseSearch({
                    'lat': lat,
                    'lon': lon
                }).then((result) => {
                    this.postalAddress = result;
                    resolve('Successfully get the address');
                })
            });
            
            
            // , (response) => {
            //     if (response) {
            //         var addr = '';

            //         if (response.address.house_number) {
            //             addr += `${response.address.house_number} `
            //         }

            //         if (response.address.road) {
            //             addr += `${response.address.road}, `
            //         }

            //         if (response.address.country == "Belgique") {
            //             addr += `${response.address.postcode} ` 
            //             addr += response.address.city || response.address.town || response.address.village || response.address.municipality
            //         }
            //         else {
            //             addr += `${response.address.postcode} ${response.address.village || response.address.town || response.address.city || response.address.municipality}`
            //         }
                    
            //         this.postalAddress = addr;
            //     }
            // });
        },
        getLocation: function (event) {
            this.resultFound = true;
            this.resultClicked = true;
            this.locations = [];
            this.locations.push(event.latlng);
            var lat = event.latlng.lat;
            var lon = event.latlng.lng;
            var promise = this.getPostalLocation(lat, lon);
            promise.then(() => {
                this.setLocation(lat,lon);
            })        
            
        },
        getLatLng: function (coords) {
            return latLng(coords[1], coords[0]);
        },
        isTagChecked: function (index) {
            var tag = this.tags[index];
            if (tag.hasOwnProperty('visible')) {
                return tag.visible;
            } else {
                tag.visible = true;
                this.tags.splice(index, 1, tag);
            }
        },
        toggleVisible: function (index) {
            var tag = this.tags[index];
            tag.visible = !tag.visible;
            this.tags.splice(index, 1, tag);
        },
        shouldShow: function (index) {
            return this.isTagChecked(index) && (this.zoom > 15);
        },
        clickOnLocation: function (location) {            
            this.resultFound = true;
            this.resultClicked = true;
            this.locations = [];
            this.locationsResult = [];
            this.postalAddress = location.address;
            var lat = location.lat;
            var lon = location.lon;
            this.locations.push(latLng(lat, lon));
            this.center = latLng(lat, lon);
            this.setLocation(lat, lon);
        }
    },
    mounted() {}
}
</script>
